export function dateModifier(date) {
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' });
}